<template>
    <div>
        <input type='hidden' v-model='$parent.item.id'>

        <div class="form-group">
            <label for='name'>Title <span class="required-field">*</span></label>
            <input type='text' v-model='$parent.item.title' class='form-control'>
        </div>

        <div v-if='is_network_admin()' class="form-group">
            <label for='name'>Scope <span class="required-field">*</span></label>
            <select v-model='$parent.item.provider_id' class='form-control' >
                <option :value='null'>{{ $t('translations.global')}}</option>
                <option v-for="(provider) in sortByValue($root.lookup.providers)" :value="provider.id" :key="provider.id">{{provider.name}}</option>
            </select>
        </div>

        <div v-if='is_admin() || is_superuser()' class="form-group">
            <b-form-group :label="this.$t('translations.scope_of_message')">
            <b-form-radio-group
                        buttons
                        value-field='value'
                        text-field='name'
                        stacked
                        v-model="$parent.item.user_id"
                        :options="scope"
                        class='btn-block'
                        button-variant="primary-outline"
                        name="scope" />
            </b-form-group>

            <inline-error type='scope'></inline-error>

            
        </div>

        <div class="form-group" v-if='($parent.item && $parent.item.user_id) || (is_staff() && !is_admin() && !is_superuser())'>
            <label for='user_global'>{{ $t('translations.user_global') | capitalise }}</label>
            <div>
                <b-form-checkbox name='user_global' size="lg" @change='updateProvider($event)' v-model="$parent.item.user_global" switch></b-form-checkbox>
            </div>
        </div>
    
        <div v-if='is_admin() || is_superuser()' class="form-group">
            <div class="form-group" v-if='$parent.item.preset_message_code && has_record_system_integration()'>
                <label>{{ $t('translations.codes')}}: </label>
                <div><coding-list :errors='$parent.errors' :value='$parent.item.preset_message_code' :editable='true' /></div>
            </div>

            <inline-error type='preset_message_code'></inline-error>
        </div>

        <div class="form-group">
            <label for='name'>{{ $t('translations.content')}} <span class="required-field">*</span></label>
            <textarea style='min-height: 260px; max-height: 480px' v-autosize='$parent.item.content' v-model='$parent.item.content' class='form-control'></textarea>
            <span class='chars-left ml-auto' aria-live="polite">{{charactersLeft}}</span>
        </div>

        

    </div>
</template>

<script>
	export default {
		props: [
		],
		data: function(){
			return {
                scope: [
                {
                    name: this.$t('translations.personal'), 
                    value: this.$root.user.id
                }, 
                {
                    name: this.$t('translations.organisational'), 
                    value: null
                }],
                inline_errors: [
                    "codes.*"
                ],
			};
		},
        mounted() {
            this.$parent.inline_errors = this.inline_errors;
        },
        computed: {
            // usergroups: {
            //     get() {
            //         var value = [];
            //         for(var index in this.$parent.item.usersusergroupindex) {
            //             value.push(this.$parent.item.usersusergroup[index].user_id);
            //         }
            //         console.log(value);
            //         return value;
            //     },
            //     set() {
            //         this.$parent.item
            //     }
            // }
            charactersLeft() {
                if(this.$parent.item.content) {
                    var char = this.$parent.item.content.length;
                    var limit = 2048;


                    if(char > limit) {
                        this.$parent.item.content = this.$parent.item.content.substr(0, limit);
                        char = this.$parent.item.content.length;
                    }
                    return (limit - char) + " " + this.$t('translations.characters_remaining');
                }
			},
        },
        methods: {
            updateProvider($event) {
                console.log($event);
                if($event) {
                    this.$parent.item.provider_id = null;
                }
                else {
                    this.$parent.item.provider_id = this.$root.provider.id;
                }
            },
            loadItem(id) {
                this.$parent.setLoading(true);
                axios.get(this.$parent.route + '/' + id).then((res) => {
                    this.$parent.item = res.data[this.$parent.model];
                    this.$parent.item.users = [];
                    for(var index in this.$parent.item.usersusergroup) {
                        this.$parent.item.users.push(this.$parent.item.usersusergroup[index].user_id);
                    }

                    this.$parent.item.user_global = this.$parent.item.provider_id ? false : true;

                    this.$parent.originalData = JSON.parse(JSON.stringify(this.$parent.item));

                    this.$parent.setLoading(false);
                    //alert(JSON.stringify(this.$parent.item.users, null, 2));
				}).catch((error) => {
                    this.$parent.setLoading(false);
                    this.$parent.handleError(error, "load");
                    this.$router.push({path: "/" + this.$parent.event + "-list"});
                });
            },
            getName() {
                return this.$parent.item.title;
            },
            resetItem() {
                this.$parent.item = {
                    preset_message_code: [],
                };
                this.$parent.errors = [];
                this.$parent.originalData = JSON.parse(JSON.stringify(this.$parent.item));
            },
        }

    }
</script>
